import React from 'react';

interface FlyerLayoutOptionSwatchProps {
  optionId: string;
  compact?: boolean;
}

const SWATCH_W = 44;
const SWATCH_H = 56;
const COMPACT_W = 28;
const COMPACT_H = 36;

const shellBase = (compact: boolean): React.CSSProperties => ({
  width: compact ? COMPACT_W : SWATCH_W,
  height: compact ? COMPACT_H : SWATCH_H,
  borderRadius: 3,
  overflow: 'hidden',
  border: '1px solid #e2e8f0',
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
});

/** Flyer Studio palette tokens aligned with the backend JobFlyerPalette. */
const COLOR_THEMES: Record<
  string,
  { top: string; bottom: string; accent: string; light?: boolean }
> = {
  'midnight-blue': { top: '#010D22', bottom: '#011430', accent: '#00B7F3' },
  'royal-blue': { top: '#0C123A', bottom: '#141F58', accent: '#A3E635' },
  azure: { top: '#03252F', bottom: '#043742', accent: '#2DD4BF' },
  cobalt: { top: '#1F1443', bottom: '#2F1D5B', accent: '#F472B6' },
  'deep-navy': { top: '#0E141E', bottom: '#18202C', accent: '#F59E0B' },
  'light-sky': {
    top: '#F8FBFF',
    bottom: '#E8F4FF',
    accent: '#0284C7',
    light: true,
  },
  'light-mint': {
    top: '#F4FFFB',
    bottom: '#E0F7EF',
    accent: '#0F766E',
    light: true,
  },
  'light-lavender': {
    top: '#FBF7FF',
    bottom: '#F1E8FF',
    accent: '#7C3AED',
    light: true,
  },
  'light-sunrise': {
    top: '#FFFAF1',
    bottom: '#FFEFD8',
    accent: '#D97706',
    light: true,
  },
  'aubergine-ember': {
    top: '#250B26',
    bottom: '#491541',
    accent: '#FF7043',
  },
  'forest-sage': {
    top: '#F8F6ED',
    bottom: '#E1EBDD',
    accent: '#B6851C',
    light: true,
  },
  'crimson-print': {
    top: '#191716',
    bottom: '#4A0F19',
    accent: '#C41230',
  },
};

export const FlyerLayoutOptionSwatch: React.FC<
  FlyerLayoutOptionSwatchProps
> = ({ optionId, compact = false }) => {
  const colors = COLOR_THEMES[optionId] ?? COLOR_THEMES['midnight-blue'];
  return (
    <div
      style={{
        ...shellBase(compact),
        background: `linear-gradient(160deg, ${colors.top} 0%, ${colors.top} 45%, ${colors.bottom} 45%)`,
        position: 'relative',
      }}
      aria-hidden
    >
      <div
        style={{
          position: 'absolute',
          bottom: compact ? 5 : 8,
          left: compact ? 4 : 6,
          width: compact ? 14 : 20,
          height: compact ? 4 : 6,
          borderRadius: 2,
          background: colors.accent,
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: compact ? 6 : 10,
          right: compact ? 4 : 6,
          width: compact ? 7 : 10,
          height: compact ? 7 : 10,
          borderRadius: '50%',
          background: colors.accent,
          opacity: colors.light ? 1 : 0.85,
        }}
      />
    </div>
  );
};

export default FlyerLayoutOptionSwatch;
